@use "ui/styles/colors";
@use "ui/styles/sizes";

.tableScroll {
  max-height: 50vh;
  overflow: auto;
}

.overrideCell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: sizes.$s4;
  select {
    max-width: calc(100% - sizes.$s8);
  }
}

.overrideButton {
  cursor: default;
  width: sizes.$s6;
  height: sizes.$s6;
  border-radius: 50%;
  display: block;
  border: 2px solid colors.$gray40;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.1s ease-in-out;

  /* Overridden State */
  &.active {
    background-color: transparent;
    cursor: pointer;
    border-color: colors.$blue;
    &::before {
      content: "";
      width: calc(sizes.$s6 - 8px);
      height: calc(sizes.$s6 - 8px);
      background-color: colors.$blue;
      border-radius: 50%;
      padding: 0;
    }

    &:hover {
      border-color: colors.$red;
      background-color: colors.$red;
      &::before {
        width: 8px;
        height: 2px;
        background-color: white;
        border-radius: 1px;
        transform: none; /* Make it look like a minus sign */
      }
    }
  }
}

.optionChanged {
  color: colors.$red;
  text-decoration: line-through;
}

.optionChangeCell {
  display: flex;
  align-items: center;
  gap: sizes.$s3;
}

.highlightPrice {
  background-color: colors.$greenLightest;
  padding: sizes.$s2 sizes.$s3;
  border-radius: sizes.$s3;
}
